export const initPricingCalculator = () => {
  const calculator = document.querySelector('.pricing-calculator');
  if (!calculator) return;
  if (calculator.dataset.pricingInit === 'true') return;
  calculator.dataset.pricingInit = 'true';

  const parsePrice = (value) => {
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const BASE_PRICE = parsePrice(calculator.dataset.basePrice);

  let state = {
    features: {},
    users: {
      additional_user: 0,
      consultation_user: 0,
      additional_dossier: 0
    },
    storage: null
  };

  const prices = {
    features: {},
    users: {},
    storage: {}
  };

  const labels = {
    features: {},
    users: {},
    storage: {}
  };

  const formatPrice = (amount) => {
    const locale = document.documentElement.lang || 'fr';
    const separator = (locale === 'en') ? '.' : ',';
    const formatted = amount.toFixed(2);
    const parts = formatted.split('.');
    return `${parts[0]}<span>${separator}${parts[1]}</span>`;
  };

  const formatLinePrice = (amount) => {
    const locale = document.documentElement.lang || 'fr';
    const separator = (locale === 'en') ? '.' : ',';
    if (Number.isInteger(amount)) {
      return amount.toString();
    }
    return amount.toFixed(2).replace('.', separator);
  };

  const updateSummary = () => {
    let total = BASE_PRICE;
    const summaryList = document.querySelector('#pricing-summary-items');
    summaryList.innerHTML = '';

    Object.keys(state.features).forEach(feature => {
      if (state.features[feature]) {
        total += prices.features[feature];
        const li = document.createElement('li');
        li.innerHTML = `<span class="item-name">${labels.features[feature]}</span><span class="item-price">€ ${formatLinePrice(prices.features[feature])}</span>`;
        summaryList.appendChild(li);
      }
    });

    Object.keys(state.users).forEach(userType => {
      const count = state.users[userType];
      if (count > 0) {
        const price = prices.users[userType] * count;
        total += price;
        const li = document.createElement('li');
        li.innerHTML = `<span class="item-name">${labels.users[userType]} ×${count}</span><span class="item-price">€ ${formatLinePrice(price)}</span>`;
        summaryList.appendChild(li);
      }
    });

    if (state.storage) {
      const storagePrice = prices.storage[state.storage];
      total += storagePrice;
      const li = document.createElement('li');
      li.innerHTML = `<span class="item-name">${labels.storage[state.storage]}</span><span class="item-price">€ ${formatLinePrice(storagePrice)}</span>`;
      summaryList.appendChild(li);
    }

    document.querySelector('#pricing-total').innerHTML = `€ ${formatPrice(total)}`;
  };

  const initFeatureToggles = () => {
    const toggles = calculator.querySelectorAll('input[data-feature]');
    toggles.forEach(toggle => {
      const featureName = toggle.dataset.feature;
      prices.features[featureName] = parsePrice(toggle.dataset.price);
      labels.features[featureName] = toggle.dataset.label || featureName;
      toggle.addEventListener('change', (e) => {
        state.features[featureName] = e.target.checked;
        updateSummary();
      });
    });
  };

  const initUserSteppers = () => {
    const steppers = calculator.querySelectorAll('.user-stepper');
    steppers.forEach(container => {
      const userType = container.dataset.userType;
      prices.users[userType] = parsePrice(container.dataset.price);
      labels.users[userType] = container.dataset.label || userType;
      const minusBtn = container.querySelector('.stepper-minus');
      const plusBtn = container.querySelector('.stepper-plus');
      const display = container.querySelector('.stepper-value');

      minusBtn.addEventListener('click', () => {
        if (state.users[userType] > 0) {
          state.users[userType]--;
          display.textContent = state.users[userType];
          updateSummary();
        }
      });

      plusBtn.addEventListener('click', () => {
        state.users[userType]++;
        display.textContent = state.users[userType];
        updateSummary();
      });
    });
  };

  const initStorageSelector = () => {
    const storageButtons = calculator.querySelectorAll('.storage-option');
    storageButtons.forEach(button => {
      const tier = button.dataset.storage;
      prices.storage[tier] = parsePrice(button.dataset.price);
      labels.storage[tier] = button.dataset.label || tier;
      button.addEventListener('click', () => {
        if (button.classList.contains('active')) {
          button.classList.remove('active');
          state.storage = null;
          updateSummary();
          return;
        }
        storageButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
        state.storage = button.dataset.storage;
        updateSummary();
      });
    });
  };

  initFeatureToggles();
  initUserSteppers();
  initStorageSelector();
  updateSummary();
};
